<template>
  <span>
    ^([\w-]+(\.[\w-]+)*@[A-Za-z0-9-]+(\.[A-Za-z0-9-]+)*(\.[A-Za-z]{2,})| )+$
  </span>
</template>
<script>
export default {
  name: 'ShowCharacter'
}
</script>